import React, { useState, useEffect, useRef, useMemo } from "react";
import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import * as XLSX from "xlsx";
import SortingArrow from "../../../src/assests/images/Sorting.svg";
import {
  Box,
  Typography,
  Button,
  Pagination,
  PaginationItem,
} from "@mui/material";
import FilterPopup from "./FilterPopup";
import PaginationComponent from "./Pagination";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import arrowleft from "../../../src/assests/images/arrow_left.svg";
import { assignusers, getalllocations, getTotalUsersExport } from "../../pages/assign-task/api";
import { useParams } from "react-router-dom";
import { getToken } from "../../utils/utils";
import { assignTask } from "../../pages/tasks-assigning/api";
import ScheduledAssign from "./ScheduledAssign";
import FilterDropdown from "./filterPopupp";
import FilterAdd from "../../../src/assests/images/filter-add.svg";
import { CircularProgress } from "@mui/material";
import Export from "../../../src/assests/images/export.svg";
import { relative } from "path/win32";

interface RowData {
  schedulemapping: string;
  userdatadata: string;
  userTaskMappingSet11: string;
  finduserretailersids: string;
  id: number;
  pmpmiEntityCodei: string;
  retailerName: string;
  outletName: string;
  outletType: string;
  location: string;
  asm: string;
  distribution: string;
  salesVolume: string;
}

interface TotalUserTableProps {
  branddetails: any[];
  totalCount: number;
  locationsCount: number;
  searchTerm: string;
  Searchlength: string;
  debouncedSearchTerm: string;
  page: number;
  limit: number;
  totalPages: number;
  branddetailslength: number;
  value: string;
  setPage: (page: number) => void;

locationsLabel11: string[];
  outletLabel22: string[];

  setLocationsLabel: React.Dispatch<React.SetStateAction<string[]>>;
  setOutletLabel: React.Dispatch<React.SetStateAction<string[]>>;

   selectedRows: number[];
  setSelectedRows: React.Dispatch<React.SetStateAction<number[]>>;
  userdatadata:string
}
interface CategoryFilter {
  category: string;
  filters: Record<string, boolean>;
}

const TotalUserTable: React.FC<TotalUserTableProps> = ({
  branddetails,
  totalCount,
  locationsCount,
  searchTerm,
  Searchlength,
  debouncedSearchTerm,
  page,
  limit,
  setPage,
  totalPages,
  branddetailslength,
  value,
  outletLabel22,
  locationsLabel11,
  setLocationsLabel,
  setOutletLabel,
  selectedRows,
  setSelectedRows,
  userdatadata
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [checkingdatad, setCheckingData] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [totalcount12length, settotalcount12length] = useState<RowData[]>([]);
  const [totalcountoutletsh22, settotalcountoultes234] = useState<
    CategoryFilter[]
  >([]);
  const [totalcountoutletsh, settotalcountoultes] = useState([]);
  const [totalcountlocations, settotalcountlocations] = useState([]);
  const [totalcountselectedlab, settotalcount12slectedtab] = useState(null);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
  const [assignData, setAssignData] = useState(null);

  // const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const popupRef = useRef<HTMLDivElement | null>(null);
  console.log(String(searchTerm), "llljjjj");
  console.log(limit, "kkkkkkkkkkkk");
  // const togglePopup = () => {
  //   setIsPopupVisible(!isPopupVisible);
  // };

  const token = getToken();

  const rows = useMemo(() => [...branddetails], [branddetails]);
  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedRows = [...rows].sort((a, b) => {
    if (!orderBy) return 0;

    const aVal = a[orderBy];
    const bVal = b[orderBy];

    if (typeof aVal === "string" && typeof bVal === "string") {
      return order === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    } else if (typeof aVal === "number" && typeof bVal === "number") {
      return order === "asc" ? aVal - bVal : bVal - aVal;
    }
    return 0;
  });

  useEffect(() => {
    if (
      location.state?.valuetabsdatapagelength ||
      location.state?.valuetabsdataselectedTab
    ) {
      console.log(
        location.state?.valuetabsdatapagelength,
        "location.state?.valuetabsdatapagelength12345"
      );

      settotalcount12length(location.state.valuetabsdatapagelength);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.valuetabsdatabrandDetailss) {
      console.log(
        location.state?.valuetabsdatabrandDetailss,
        "location.state?.valuetabsdatabrandDetailss"
      );

      settotalcountoultes234(location.state?.valuetabsdatabrandDetailss);
    }
  }, [location.state]);

  useEffect(() => {
    const hasActiveFilters = totalcountoutletsh22.some((category) =>
      Object.entries(category.filters).some(
        ([key, value]) => value === true && key !== "All" && key !== "AllTypes"
      )
    );

    if (hasActiveFilters) {
      setCheckingData(hasActiveFilters);
      console.log(
        "There are active filters (excluding 'all' and 'allTypes').",
        hasActiveFilters
      );
    } else {
      console.log("No active filters found.");
    }
  }, [totalcountoutletsh22]);
  console.log(
    totalcountoutletsh22,
    "totalcountoutletsh22totalcountoutletsh22totalcountoutletsh22"
  );
  console.log(checkingdatad, "checkingdatadcheckingdatadcheckingdatad");

  const handleCheckboxChange = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedRows(rows.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };
  console.log(selectedRows, "selectedRowsselectedRows");
  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setIsPopupVisible(false);
    }
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      navigate(`/assign-task/${id}`, {
        state: { valuetabsdatapagelengthselectedRows: selectedRows },
      });
    }
  }, [selectedRows]);

  const { id } = useParams();

  useEffect(() => {
    if (isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupVisible]);
  const totalPagesw = Math.ceil(
    Number(
      totalcount12length.length
        ? totalcount12length.length
        : debouncedSearchTerm
          ? branddetailslength
          : !checkingdatad
            ? totalCount
            : 0
    ) / Number(limit)
  );
  console.log(
    JSON.stringify(totalcount12length, null, 2),
    "totalcount12lengthtotalcount12lengthtotalcount12length"
  );

  console.log(isPopupVisible, "isPopupVisibleisPopupVisible");

  console.log(typeof totalcountselectedlab, "totalcountselectedlab");

  // const [isPopupOpen, setPopupOpen] = useState(false);
  // const [rows, setRows] = useState<RowData[]>([]); // Define your RowData type as necessary
  // const [tabsConfig, setTabsConfig] = useState([
  //   { key: "category", label: "Category" },
  //   { key: "brand", label: "Brand" },
  //   { key: "priceRange", label: "Price Range" },
  // ]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [selectedFilters, setSelectedFilters] = React.useState<
    Record<string, boolean>
  >({});
  const [loading, setLoading] = useState(true);

  const togglePopup = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the popover
  };

  const handleApplyFilters = (
    filters: Record<string, { option: string; label: string }>
  ) => {
    const booleanFilters: Record<string, boolean> = Object.fromEntries(
      Object.keys(filters).map((key) => [key, true]) // or any logic that converts it to boolean
    );
    setSelectedFilters(booleanFilters); // Update the selected filters in the parent state
    setAnchorEl(null); // Close the popover
    console.log("Applied Filters:", booleanFilters); // Debugging or usage logic
  };

  useEffect(() => {
    const fetchDropdownCities = async () => {
      try {
        setLoading(true);
        const response = await getalllocations();
        console.log(response, "API Response");

        const cities = response.data.data;
        console.log(cities, "Cities Data");

        // Assuming the city has a name or id property that should be used as the key
        const locations = cities.reduce((acc: any, city: any) => {
          acc[city.name] = false; // Replace `city.name` with the correct key if needed
          return acc;
        }, {});

        console.log(locations, "locationslocations333333333333");
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownCities();
  }, []);

  const tabsConfig = [
    { key: "tab0", label: "Outlet Type", options: [""] },
    { key: "tab1", label: "Location", options: ["All Locations"] },
    // { key: "tab2", label: "Distributors", options: ["Distributors Type1", "Distributors Type1"] },
    // { key: "tab3", label: "ASM", options: ["ASM Type1", "ASM Type 2"] },
    // { key: "tab4", label: "Sales Volume", options: ["Sales Type1", "Sales Type 2"] },
    // {
    //   key: "tab5",
    //   label: "Reassign count",
    //   options: ["Reassign count 3", "Reassign count 4"],
    // },
    // { key: "tab6", label: "Last Login", options: ["Login 3", "Login 4"] },
  ];


const autoSelectIds = useMemo(() => rows.filter(r => {
  if (userdatadata === "Assign now") {
    return r.finduserretailersids === "disable"
  } else if (userdatadata === "Schedule now") {
    return r.schedulemapping === "disable"
  } else {
    return false
  }
}).map(r => r.id), [rows, userdatadata]);

useEffect(() => {
  setSelectedRows(prev => {
    const set = new Set(prev);
    autoSelectIds.forEach(id => set.add(id));
    const newArr = Array.from(set);
    if (prev.join(',') === newArr.join(',')) {
      return prev;
    }
    return newArr;
  });
}, [autoSelectIds]);


const autoFitColumns = (worksheet: XLSX.WorkSheet) => {
  const jsonData = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
  }) as (string | number | boolean | null)[][];

  if (jsonData.length === 0) return;

  const colWidths: number[] = jsonData[0].map((_, colIndex) =>
    Math.max(
      ...jsonData.map((row) =>
        row[colIndex] ? row[colIndex]!.toString().length : 0
      )
    ) + 2 // add padding
  );

  worksheet["!cols"] = colWidths.map((w: number) => ({ wch: w }));
};
console.log(outletLabel22, "valuesss33333333333")
const handleExportClick = async () => {
  try {
     const selectedIdsParam = selectedRows.length > 0 ? selectedRows.join(",") : "";

    const response = await getTotalUsersExport(
      token,
      (locationsLabel11 ?? [])
        .filter((label) => label.trim() !== "All Locations")
        .join(","),
      selectedIdsParam,
      Number(value) === 2 ? debouncedSearchTerm : "",
      (outletLabel22 ?? [])
        .filter((label) => label.trim() !== "All Outlet Types")
        .join(","),
      id
    );
    // Convert API blob → workbook
    const data = await response.data.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });

    // Adjust each worksheet’s columns
    workbook.SheetNames.forEach((sheetName) => {
      const worksheet = workbook.Sheets[sheetName];
      autoFitColumns(worksheet);
    });

    // Export adjusted workbook
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "cohort_1.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error exporting XLSX:", error);
  }
};

  console.log(sortedRows, "totalcount12lengthssssss")
  return (
    <Box sx={{ background: "#F9FBFC", marginTop: "10px", marginBottom: "70px" }}>
      <Box>
        {/* <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            marginBottom: "30px",

            marginLeft: "16px",
            marginTop: "-70px"
          }}
        >
          Select folder to assign the tasks
        </Typography> */}
         <Button
                          variant="contained"
                          sx={{
                            textTransform: "capitalize",
                            position: "relative",
                            bottom: "-64px",
                            left: "855px",
                            backgroundColor: "#fff",
                            width: "150px",
                            fontSize: "14px",
                            fontWeight: "500",
                            height: "10px",
                            padding: "16px",
                            borderRadius: "10px",
                            color: "#C8172F",
                            border: "1px solid #C8172F",
                            boxShadow: "none",
                            "&:hover": {},
                            "& .MuiButton-endIcon": {
                              fontSize: "30px",
                              color: "var(--Icon-Colour, #C8172F)",
                            },
                            "&:before, &:after": {
                              border: "none",
                            },
                          }}
                          startIcon={<img src={Export} alt="export"></img>}
                          onClick={() => handleExportClick()}
                        >
                          Export CSV
                        </Button>

      </Box>
      <Box sx={{ padding: "0 10px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            border: "1px solid #e0e0e0",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            boxShadow: "-1px 1px 1px #e7e8e9"
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: "18px",
              color: "#282829",
              fontWeight: "600",
              padding: "20px",
              background: "#fff",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",

            }}
          >
            <div>
              Total {totalCount ? totalCount : 0}       Users
            </div>
          </Typography>
          <Box>
            <Button
              variant="contained"
              onClick={togglePopup}
              sx={{
                textTransform: "capitalize",
                backgroundColor: "#fff",
                height: "44px",
                padding: "7px 12px",
                margin: "20px",
                borderRadius: "10px",
                color: "#565656",
                border: "1px solid #DEDEDE",

                boxShadow: "none",
                fontSize: "14px",
                fontWeight: "500",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
              startIcon={<img src={FilterAdd} alt="filter-add" />}
            >
              Filters
            </Button>

            {/* Render FilterDropdown */}
            <FilterDropdown
              anchorEl={anchorEl}
              onClose={handleClose}
              tabsConfig1={tabsConfig}
              onApply={handleApplyFilters}
               locationsLabel11={locationsLabel11}
        outletLabel22={outletLabel22}
        setLocationsLabel={setLocationsLabel}
        setOutletLabel={setOutletLabel}
            // tabsConfig={tabsConfig} // Pass tabsConfig to FilterDropdown
            />
          </Box>
        </Box>
        <TableContainer component={Paper} sx={{ border: "1px solid rgba(231, 232, 233, 1)", borderTop: "0", borderBottom: "0", borderBottomLeftRadius: "0", borderBottomRightRadius: "0" }}>
          <Table sx={{ minWidth: 650 }} aria-label="sortable table">
            <TableHead sx={{ background: "#EEF4FF" }}>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    onChange={handleSelectAll}
                    checked={selectedRows.length === rows.length}
                    disabled={userdatadata === "Assign now"}
                    sx={{
                      color: "#E7E8E9",
                      "&.Mui-checked": {
                        color: "#0073e6",
                      },
                    }}
                  />
                </TableCell>
                {[
                  { label: "PMI Entity Code", key: "pmpmiEntityCodei" },
                  { label: "Retailer Name", key: "retailerName" },
                  { label: "Outlet Name", key: "outletName" },
                  { label: "Outlet Type", key: "outletType" },
                  { label: "Location", key: "location" },
                  // { label: "ASM", key: "asm" },
                  // { label: "Distribution", key: "distribution" },
                  // { label: "Sales Volume", key: "salesVolume" },
                ].map((col, index) => (
                  <TableCell key={col.key}>
                    <TableSortLabel
                      active={orderBy === col.key}
                      direction={orderBy === col.key ? order : "asc"}
                      onClick={() => handleSort(col.key as keyof RowData)}
                      hideSortIcon={false}
                      IconComponent={() => (
                        <img
                          src={SortingArrow}
                          alt="Sort Icon"
                          style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
                        />
                      )}
                      sx={{

                        "& .MuiTableSortLabel-icon": {
                          opacity: 1,
                        },
                      }}
                    >
                      {col.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loading ? (
              <CircularProgress />
            ) : (
              <TableBody>
                {totalcount12length && totalcount12length.length > 0 ? (
                  totalcount12length.map((row, index) => (
                    <TableRow key={row.id} sx={{ backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent", }}>
                      <TableCell padding="checkbox">
                        {/* <Checkbox
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleCheckboxChange(row.id)}
                          sx={{
                            color: "#E7E8E9",
                            borderRadius: "30px",
                            "&.Mui-checked": {
                              color: "#0073e6",
                            },
                          }}
                        /> */}
                      </TableCell>
                      <TableCell>{row.pmpmiEntityCodei}</TableCell>
                      <TableCell>{row.retailerName}</TableCell>
                      <TableCell>{row.outletName}</TableCell>
                      <TableCell>{row.outletType}</TableCell>
                      <TableCell>{row.location}</TableCell>
                      {/* <TableCell>{row.asm}</TableCell>
                      <TableCell>{row.distribution}</TableCell>
                      <TableCell>{row.salesVolume}</TableCell> */}
                    </TableRow>
                  ))
                ) : !checkingdatad && sortedRows.length > 0 ? (
                  sortedRows.map((row, index) => (
                    <TableRow key={row.id} sx={{ backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent", }}>
                      <TableCell padding="checkbox">
                        {userdatadata === "Assign now" ? (
                          row.finduserretailersids === "disable" ? (
                            <Checkbox
                              checked={true}
                              disabled={true}
                              sx={{
                                color: "#E7E8E9",
                                borderRadius: "30px",
                                "&.Mui-checked": {
                                  color: "#0073e6",
                                },
                              }}
                            />
                          ) : null
                        ) : (
                          <Checkbox
                            checked={selectedRows.includes(row.id)}
                            onChange={() => handleCheckboxChange(row.id)}
                            sx={{
                              color: "#E7E8E9",
                              borderRadius: "30px",
                              "&.Mui-checked": {
                                color: "#0073e6",
                              },
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>{row.pmpmiEntityCodei}</TableCell>
                      <TableCell>{row.retailerName}</TableCell>
                      <TableCell>{row.outletName}</TableCell>
                      <TableCell>{row.outletType}</TableCell>
                      <TableCell>{row.location}</TableCell>
                      {/* <TableCell>{row.asm}</TableCell>
                      <TableCell>{row.distribution}</TableCell>
                      <TableCell>{row.salesVolume}</TableCell> */}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No results found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
      <Box
        sx={{
          padding: "10px 10px",
          background: "#fff",
          border: "1px solid #dadada",
          borderTop: "0",
          margin: "0 10px",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px",
          boxShadow: "-1px 1px 1px #e7e8e9"
        }}
      >
        <PaginationComponent
          page={page}
          limit={limit}
          setPage={setPage}
          totalPages={totalPagesw}
        />
      </Box>
    </Box>
  );
};

export default TotalUserTable;